import "whatwg-fetch"

import "typeface-work-sans"
import "typeface-open-sans"
import "./src/utils/forms.css"
import "./src/base.scss"
import "lazysizes"

/*eslint-disable */
export const onClientEntry = () => {}
/*eslint-enable */
